<i18n>
{
  "en":{
    "Label": "Delete"
  },
  "fr":{
    "Label": "Supprimer"
  }
}
</i18n>

<template>
  <button
    :type="type"
    class="btn btn-danger"
    @click="$emit('click')">
    <IconDelete />
    <span class="d-inline-block ml-2">{{ computedLabel }}</span>
  </button>
</template>

<script>
import { computed, props } from '.';

export default {
  props,
  computed,
};
</script>
